
import Vue, { PropType } from "vue";
import BaseInputForm from "@/components/BaseInputForm.vue";
import { CompanyUser } from "@/models";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";

export type DataType = {
  name: string;
  mail: string;
};

export default Vue.extend({
  name: "CompanyUserEditor",

  components: {
    BaseInputForm,
    BaseSubmitButton,
    BaseCancelButton
  },

  props: {
    companyUser: Object as PropType<CompanyUser>
  },

  data(): DataType {
    return {
      name: "",
      mail: ""
    };
  },

  computed: {
    isEdited(): boolean {
      return (
        this.companyUser.name !== this.name ||
        this.companyUser.mail !== this.mail
      );
    },

    canSubmit(): boolean {
      return !!this.name && !!this.mail && (!this.companyUser || this.isEdited);
    }
  },

  watch: {
    companyUser: function(n: CompanyUser) {
      this.name = n.name || "";
      this.mail = n.mail || "";
    }
  },

  methods: {
    saveCompanyUser(): void {
      if (!this.canSubmit) return;
      this.$emit(
        "save-company-user",
        new CompanyUser({
          name: this.name,
          mail: this.mail
        })
      );
    }
  }
});
